import { render, staticRenderFns } from "./slot_time_tips_comp.vue?vue&type=template&id=0465b0b0&scoped=true"
import script from "./slot_time_tips_comp.vue?vue&type=script&lang=js"
export * from "./slot_time_tips_comp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0465b0b0",
  null
  
)

export default component.exports